// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-chart {
	background-color: #fff;
	min-width: 100% !important;
	border-radius: 10px;
	min-height: 100px;
	padding: 40px 35px;
	margin-top: 10px;
	position: relative;
	border: 2px solid #9e8bff;
}

.box-chart {
	border-bottom: 1px solid #000;
	border-top: none;
	border-left: none;
	border-right: none;
}

.number-box-chart {
	position: relative;
	top: 60px;
	left: 35%; /* Ajusta la posición horizontal según tus necesidades */
}

.quarter-chart {
	position: relative; /* Establece la posición en relativa */
	width: 100%;
	min-height: 70px;
}

.quarter-chart::before {
	content: '';
	position: absolute;
	top: 0;
	bottom: 0;
	left: 50%; /* Coloca el borde en el centro del elemento */
	border-left: 1px solid #6d68aa; /* Establece el estilo del borde izquierdo */
}

/* Estilo adicional para el elemento resaltado (index === 2) */
.quarter-chart.highlighted::before {
	background-color: #6d68aa; /* Cambia el color de fondo del borde izquierdo */
}

.circle {
	width: 20px;
	height: 20px;
	background-color: #f84228;
	border-radius: 50%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;
}

.blue-circle {
	width: 20px;
	height: 20px;
	background-color: #41c9ff;
	border-radius: 50%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2; /* Cambiamos el índice z a 1 para que esté detrás del círculo rojo o verde */
}

.line-horizontal {
	position: absolute;
	border-top: 2px solid #000; /* Línea horizontal con un grosor de 2px y color negro */
	width: 100%; /* Ancho de la línea horizontal al 100% para cubrir todo el contenedor */
	top: 50%; /* Posición vertical centrada */
	transform: translateY(-50%);
	z-index: 1;
}

.alignQuarters {
	position: relative;
	right: -13px;
	top: -10px;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/PayBalance/Components/SalaryComparativeChart.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS,EAAE,wDAAwD;AACpE;;AAEA;CACC,kBAAkB,EAAE,sCAAsC;CAC1D,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,SAAS,EAAE,8CAA8C;CACzD,8BAA8B,EAAE,4CAA4C;AAC7E;;AAEA,8DAA8D;AAC9D;CACC,yBAAyB,EAAE,iDAAiD;AAC7E;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,UAAU,EAAE,4EAA4E;AACzF;;AAEA;CACC,kBAAkB;CAClB,0BAA0B,EAAE,wDAAwD;CACpF,WAAW,EAAE,wEAAwE;CACrF,QAAQ,EAAE,+BAA+B;CACzC,2BAA2B;CAC3B,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;AACX","sourcesContent":[".container-chart {\r\n\tbackground-color: #fff;\r\n\tmin-width: 100% !important;\r\n\tborder-radius: 10px;\r\n\tmin-height: 100px;\r\n\tpadding: 40px 35px;\r\n\tmargin-top: 10px;\r\n\tposition: relative;\r\n\tborder: 2px solid #9e8bff;\r\n}\r\n\r\n.box-chart {\r\n\tborder-bottom: 1px solid #000;\r\n\tborder-top: none;\r\n\tborder-left: none;\r\n\tborder-right: none;\r\n}\r\n\r\n.number-box-chart {\r\n\tposition: relative;\r\n\ttop: 60px;\r\n\tleft: 35%; /* Ajusta la posición horizontal según tus necesidades */\r\n}\r\n\r\n.quarter-chart {\r\n\tposition: relative; /* Establece la posición en relativa */\r\n\twidth: 100%;\r\n\tmin-height: 70px;\r\n}\r\n\r\n.quarter-chart::before {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 50%; /* Coloca el borde en el centro del elemento */\r\n\tborder-left: 1px solid #6d68aa; /* Establece el estilo del borde izquierdo */\r\n}\r\n\r\n/* Estilo adicional para el elemento resaltado (index === 2) */\r\n.quarter-chart.highlighted::before {\r\n\tbackground-color: #6d68aa; /* Cambia el color de fondo del borde izquierdo */\r\n}\r\n\r\n.circle {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tbackground-color: #f84228;\r\n\tborder-radius: 50%;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n\tz-index: 2;\r\n}\r\n\r\n.blue-circle {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tbackground-color: #41c9ff;\r\n\tborder-radius: 50%;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n\tz-index: 2; /* Cambiamos el índice z a 1 para que esté detrás del círculo rojo o verde */\r\n}\r\n\r\n.line-horizontal {\r\n\tposition: absolute;\r\n\tborder-top: 2px solid #000; /* Línea horizontal con un grosor de 2px y color negro */\r\n\twidth: 100%; /* Ancho de la línea horizontal al 100% para cubrir todo el contenedor */\r\n\ttop: 50%; /* Posición vertical centrada */\r\n\ttransform: translateY(-50%);\r\n\tz-index: 1;\r\n}\r\n\r\n.alignQuarters {\r\n\tposition: relative;\r\n\tright: -13px;\r\n\ttop: -10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
